import './index.scss'
import {
  FileUploader,
  FileUploaderItem,
  FileUploaderDropContainer,
  FileUploaderButton,
  FormItem
} from 'carbon-components-react'

FileUploader.Container = FileUploaderDropContainer
FileUploader.Item = FileUploaderItem
FileUploader.Button = FileUploaderButton
FileUploader.FormItem = FormItem

export {
  FileUploader,
  FileUploaderDropContainer,
  FileUploaderItem,
  FileUploaderButton,
  FormItem,
  FileUploader as default
}
